const timer = async (milliseconds: number) =>
  new Promise((res) => {
    setTimeout(res, milliseconds);
  });

export default timer;
